export default "__VITE_PUBLIC_ASSET__84db60d4__"